import { PageMeta, faqPageJsonLd } from "@musicfy/components/Seo";

export const FAQ_ITEMS: { question: string; answer: string }[] = [
  {
    question: "Can I use musicfy commercially or in my music?",
    answer:
      "Yes all music generated from musicfy belongs to the user who generated the audio. This means you have full mechanical rights + recording rights of music generated from our artist and any custom models trained by you.",
  },
  {
    question: "Can I upgrade or downgrade my plan?",
    answer:
      "You can change plans at any time by visiting account settings and clicking on 'Change Plan'. If you upgrade you will be pro-rated (only pay the difference). If you downgrade you will have a discount applied to future months.",
  },
  {
    question: "How do I cancel my plan?",
    answer:
      "You can cancel your plan at any time and keep access until the end of your billing period. To manage your plan, visit account settings.",
  },
  {
    question: "What happens when I cancel my subscription?",
    answer:
      "When you cancel your subscription, you will still have access to your account until the end of your billing period. After that, you will lose access to your premium features and all of your models.",
  },
  {
    question: "Where can I ask more questions?",
    answer:
      "Please join our Discord community by clicking on the support button in the navigation menu. We're usually online and happy to answer any questions. You can also contact us at team@musicfy.lol.",
  },
  {
    question: "Can I keep my recordings private + voice models?",
    answer:
      "All recordings and voice models are stored privately for every user and no one will ever have access to it other than you.",
  },
];

const FrequentlyAskedQuestions: React.FC<{
  question: string;
  answer: string;
}> = ({ question, answer }) => {
  return (
    <div>
      <div className="font-bold">{question}</div>
      <div className="mt-4 text-gray-500">{answer}</div>
    </div>
  );
};

const FAQ: INextPage = () => {
  return (
    <div className="pb-4">
      <PageMeta
        title="Musicfy AI - FAQ"
        description="Get answers to the most common questions about using Musicfy AI."
        canonicalPath="/support/faq"
        robots="index,follow"
        includeFavicon={false}
        jsonLd={faqPageJsonLd(FAQ_ITEMS)}
      />
      <div className="text-[40px] font-bold text-center lg:text-left">
        Frequently Asked Questions:
      </div>
      <div className="mt-9 grid grid-cols-1 gap-12 lg:grid-cols-2">
        {FAQ_ITEMS.map(({ question, answer }) => (
          <FrequentlyAskedQuestions
            key={question}
            question={question}
            answer={answer}
          />
        ))}
      </div>
    </div>
  );
};

FAQ.seo = true;

export default FAQ;
